<template>
  <fieldset :disabled="loading" :class="{ loading: loading }">
    <table
      class="table table-borderless"
      :id="tableId"
      :class="{ 'table-striped': hasRecord, 'table-hover': hasRecord }"
    >
      <thead>
        <th v-if="!hideDetailsCommand" style="width: 1px"></th>
        <th v-if="!hideDeleteCommand" style="width: 1px"></th>
        <th v-for="c in availableColumns" :key="c.Key" :class="c.Class">
          <a v-if="c.SortField" href="#void" @click.prevent="sort(c)">
            {{ c.Title }}
            <template v-if="c.SortField == currentSortField">
              <span v-if="currentSortDirection == 'desc'">
                <svg
                  width="1em"
                  height="1em"
                  viewBox="0 0 16 16"
                  class="bi bi-chevron-up"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"
                  />
                </svg>
              </span>
              <span v-else>
                <svg
                  width="1em"
                  height="1em"
                  viewBox="0 0 16 16"
                  class="bi bi-chevron-down"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                  />
                </svg>
              </span>
            </template>
          </a>
          <template v-else>{{ c.Title }}</template>
        </th>
      </thead>
      <tbody>
        <tr v-if="errorMessage">
          <td
            :colspan="columns.length + (hideDetailsCommand ? 0 : 2)"
            class="text-center text-danger"
            style="padding: 40px; font-style: italic"
          >
            {{ errorMessage }}
          </td>
        </tr>
        <tr v-else-if="!hasRecord">
          <td
            :colspan="columns.length + (hideDetailsCommand ? 0 : 2)"
            class="text-center text-muted"
            style="padding: 40px; font-style: italic"
          >
            <span v-if="loading">{{translate('loading')}}</span>
            <span v-else>{{ noDataText || translate('noDataToShow') }}</span>
          </td>
        </tr>
        <tr
          v-else
          v-for="i in data.Result"
          :key="i.Id"
          @dblclick.prevent="
            $router.push({ name: detailRouterName, params: { id: i.Id } })
          "
        >
          <td
            v-if="!hideDetailsCommand"
            style="padding-left: 18px"
            class="text-center"
          >
            <router-link
              :to="{ name: detailRouterName, params: { id: i.Id } }"
              title="Düzenle"
            >
              <svg
                class="bi bi-pencil-square"
                width="1em"
                height="1em"
                viewBox="0 0 16 16"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456l-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"
                />
                <path
                  fill-rule="evenodd"
                  d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                />
              </svg>
            </router-link>
          </td>
          <td v-if="!hideDeleteCommand" class="text-center">
            <button
              class="btn btn-link"
              @click.prevent="remove(i.Id)"
              style="padding: 0"
              title="Kaldır"
            >
              <svg
                width="1em"
                height="1em"
                viewBox="0 0 16 16"
                class="bi bi-trash text-danger"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"
                />
                <path
                  fill-rule="evenodd"
                  d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4L4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                />
              </svg>
            </button>
          </td>
          <td
            v-for="c in availableColumns"
            :key="c.Key"
            :class="c.Class"
            :style="c.Style"
            
          >            
            <img v-if="c.Key == 'ProfilePictureUrl'" v-auth-image="i[c.Key]" class="profile-picture-small" alt="Profile Picture">
            <span v-else           
              v-html="
                typeof c.Content === 'function'
                  ? c.Content(i)
                  : String.cleanHtml(i[c.Key])
            "></span>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="rbcontent">
      <div class="row">
        <div class="col-md-6">
          <nav class="pull-left">
            <ul class="pagination">
              <li class="page-item" :class="{ disabled: page <= 1 }">
                <button
                  class="page-link"
                  href="#"
                  @click.prevent="
                    page -= 1;
                    getData();
                  "
                >
                  &laquo;
                </button>
              </li>
              <li>
                <select
                  class="page-item form-control"
                  v-model="page"
                  @change="getData()"
                >
                  <option
                    v-for="(v, i) in new Array(pageCount)"
                    :key="i"
                    :value="i + 1"
                  >
                    {{ i + 1 }}
                  </option>
                </select>
              </li>
              <li class="page-item" :class="{ disabled: page >= pageCount }">
                <button
                  type="button"
                  class="page-link"
                  href="#"
                  @click.prevent="
                    page += 1;
                    getData();
                  "
                >
                  &raquo;
                </button>
              </li>
            </ul>
          </nav>
        </div>
        <div class="col-md-6 text-muted text-right">
          <span>{{ translate('list.totalRecordCount:' + pageCount + ':' + data.TotalRecordCount) }}</span>
        </div>
      </div>
    </div>
  </fieldset>
</template>
<script>
import axios from "axios";

export default {
  created() {
    this.data.Filter.OrderBy = this.orderBy;
  },
  mounted() {
    this.getData();
  },
  watch: {
    "$route.params.id": function (id) {
      if (!id) {
        this.getData();
      }
    },
  },
  data() {
    return {
      errorMessage: null,
      loading: false,
      data: {
        TotalRecordCount: 0,
        Result: [],
        Filter: {
          Skip: 0,
          Take: this.recordPerPage,
        },
      },
    };
  },
  computed: {
    hasRecord() {
      return this.data && this.data.Result && this.data.Result.length;
    },
    pageCount() {
      return (
        Math.ceil((this.data?.TotalRecordCount ?? 0) / this.recordPerPage) ?? 1
      );
    },
    currentSortField() {
      return this.data?.Filter?.OrderBy?.split(" ")[0];
    },
    currentSortDirection() {
      return this.data?.Filter?.OrderBy?.split(" ")[1] ?? "asc";
    },
    availableColumns() {
      var columns = this.columns.filter(x => typeof(x.IsVisible) == 'function' ? x.IsVisible() : (typeof(x.IsVisible) == 'undefined' ? true : x.IsVisible));

      if (this.exportOperation) {
        return columns.filter((x) => x.HideIfExport != true);
      } else {
        return columns.filter((x) => x.ExportOnly != true);
      }
    },
    detailRouterName () {
      return this.routerName || (this.modelName + 'Detail')
    }
  },
  props: {
    tableId: String,
    modelName: String, // Veri modelinin adı
    routerName: String, // Detay tıklandığında açılacak link adı. Boş geçilir ise modelName + 'Detail' açılır
    url: String, // Verinin çekileceği API url'i
    hideDetailsCommand: Boolean, // Detay butonunu gizle
    hideDeleteCommand: Boolean, //Sil buttonunu gizle
    columns: Array, // Sütunlar
    noDataText: String, // Veri bulunamadığında gösterilecek metin
    predicate: String, //
    orderBy: String, // Sıralama
    filter: Object, // Filtre nesnesi
    listType: String, //Liste Tipi (örn MyWaiting)
    exportOperation: Boolean,
    page: {
      type: Number,
      default: () => 1,
    },
    recordPerPage: {
      type: Number,
      default() {
        return 10;
      },
    },
  },
  methods: {
    getData() {
      this.errorMessage = null;
      this.loading = true;
      var f = this.data?.Filter || {};

      if (this.filter && typeof this.filter === "object")
        Object.assign(f, this.filter);

      f.Skip = (Math.max(this.page, 1) - 1) * this.recordPerPage;
      f.Take = this.recordPerPage;
      f.Predicate = this.predicate;
      if(this.listType){
        f.ListType = this.listType
      }

      axios
        .post(this.url, f)
        .then((x) => {
          console.log("POST Result:", x.data);
          this.data = x.data;
          if (this.page > this.pageCount) {
            this.page = 1;
            if(this.loading) {
              this.getData();
            }
          }
          this.$forceUpdate();
          this.$emit("onload");
          
        })
        .catch((x) => {
          window.processErrorResponse(x, this);
          //this.$emit("onerror", "İşlem gerçekleştirilemedi: " + x);
        })
        .then(() => {
          this.loading = false;
        });
    },
    remove(id) {
      if(id === this.$root.$data.login.User.Id) {
        alert(this.translate('errors.cantDeleteOwnUser'));
        return;
      }
      if (confirm(this.translate('warnings.sureToDelete'))) {
        this.loading = true;
        this.errorMessage = null;
        return axios
          .post(`/${this.modelName}/delete/${id}`, this.data)
          .then(() => {
            this.loading = false;
            localStorage.removeItem(this.modelName)
            this.getData();
          })
          .catch((x) => window.processErrorResponse(x, this));
      }
    },
    sort(column) {
      console.log("Sort: ", column);
      this.data.Filter.OrderBy =
        column.SortField +
        " " +
        (this.currentSortDirection == "desc" ? "" : "desc");
      this.getData();
    },
  },
};
</script>

<style scoped>
.btn-export {
  margin-left: 10px;
  margin-right: 10px;
}
fieldset {
  transition: opacity 0.15s ease-in-out;
}

fieldset.loading {
  opacity: 0.5;
}

select.page-item {
  text-align: right;
  width: 100px;
  height: calc(1.5em + 0.75rem + 2px);
  border-radius: 0;
  border-left: 0;
  border-right: 0;
}
</style> 